<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>

    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <div class="inner-header--create">
              <strong class="mr-auto"> Crea una nuova collaborazione orizzontale </strong>
              <b-button
                class="btn btn--create btn--smaller"
                type="button"
                variant="primary"
                size="sm"
                @click="onAdd"
                title="Crea una nuova collaborazione orizzontale"
                :disabled="!canVerb(resource, 'store')"
              >
                <base-icon name="circled_plus" width="16" height="16" />
                <span>Crea</span>
              </b-button>
            </div>
            <div class="inner-header--info">
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </div>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="AGFRNAME"
                type="text"
                label="Nominativo"
                v-model="filter.byCustom.title.value"
                placeholder="Inserisci un nominativo"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="NINO"
                type="text"
                label="Codice Fiscale"
                v-model="filter.byAttribute.NINO"
                placeholder="Inserisci un codice fiscale"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="CREG"
                type="text"
                label="Partita IVA"
                v-model="filter.byCustom.CREG.value"
                placeholder="Inserisci una Partita IVA"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="BUID"
                type="text"
                label="Codice Univoco Lisaweb"
                v-model="filter.byAttribute.BUID"
                placeholder="Inserisci un codice univoco Lisaweb"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <cooperators
        @edit="onEdit"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterName="filterName"
        @destroy="onDestroy"
        :onlyActions="['edit', 'destroy', 'infomodal']"
        :filterOn="{
          byRelations: ['byCorrespondence', 'byAddressBook'],
        }"
        :ref="tableRef"
      ></cooperators>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import Cooperators from "@/components/tables/Cooperators.vue";
import BaseInput from "@/components/form/BaseInput";
import { mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "broker",
      resource: "brokers",
      tableRef: "CooperatorTableRef",
      filterName: "filterCooperator",
      filter: this.initFilter(),
      activeFilters: {},
      performedSearch: false,
      fields: [
        {
          key: "attributables.BUID",
          label: this.getDictionary("attribute_BUID_value", "broker"),
          sortable: true,
          sortKey: "BUID",
        },
        {
          key: "attributables.SURN",
          label: this.getDictionary("attribute_SURN_value", "broker"),
          sortable: true,
          sortKey: "SURN",
        },
        {
          key: "attributables.NAME",
          label: this.getDictionary("attribute_NAME_value", "broker"),
          sortable: true,
          sortKey: "NAME",
        },
        {
          key: "attributables.CNAM",
          label: this.getDictionary("attribute_CNAM_value", "broker"),
          sortable: true,
          sortKey: "CNAM",
        },
        {
          key: "correspondences[0]",
          label: this.getDictionary("attribute_address", "broker"),
          formatter: (value) => {
            return this.formatAddress(value);
          },
          sortable: false,
        },
        {
          key: "attributables.ROBR",
          label: this.getDictionary("attribute_RUI_value", "broker"),
          sortable: false,
        },
        {
          key: "attributables.WHT",
          label: this.getDictionary("attribute_ritenuta_value", "broker"),
          formatter: (value) =>
            value ? value.toString().replace(".", ",") + " %" : "-",
          sortable: false,
        },
        {
          key: "status_broker.text",
          label: this.getDictionary("status_broker", "broker"),
        },
      ],
    };
  },
  components: {
    BaseIcon,
    Cooperators,
    BaseInput,
  },
  created() {
    /* */
    // debugger;
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      // this.getResources("auth/councils");
      // resources.push({
      //   path: path,
      //   value: "councils",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            // const defaultCountryId = this.getCountries().find(
            //   (country) => country.text == this.defaultCountryName
            // ).value;
            // this.opt_provinces = this.getProvinces()(defaultCountryId);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    }
    // else {
    //   const defaultCountryId = this.countries().find(
    //     (country) => country.text == this.defaultCountryName
    //   ).value;
    //   this.opt_provinces = this.provinces()(defaultCountryId);
    // }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          // const defaultCountryId = this.countries().find(
          //   (country) => country.text == this.defaultCountryName
          // ).value;
          // this.opt_provinces = this.provinces()(defaultCountryId);
          // this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
          // this.$emit("storageLoading", false);
        });
    } else {
      this.isLoading = false;
      // this.$emit("storageLoading", false);
    }
    /* */
    // const defaultCountryId = this.countries().find(
    //   (country) => country.text == this.defaultCountryName
    // ).value;
    // this.opt_provinces = this.provinces()(defaultCountryId);
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    formatAddress(value) {
      if (
        value?.geo_location &&
        value.geo_location?.COUNCIL &&
        value.geo_location?.PRVCODE &&
        value?.attributables &&
        value.attributables?.ADDR
      ) {
        let str = `${value.attributables.ADDR.toLowerCase()}, ${
          value.geo_location.COUNCIL
        } (${value.geo_location.PRVCODE})`;
        return str ? str.charAt(0).toUpperCase() + str.slice(1) : "-";
      }
      return "-";
    },
    initFilter() {
      let init = {
        byAttribute: {
          status_broker: 1,
          code: null,
          BUID: null,
        },
        byCustom: {
          title: {
            value: null,
            likewise: 1,
            filter: "byAttribute",
          },
          CREG: {
            value: null,
            likewise: 2,
            filter: "byAttribute",
          },
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id, item) {
      this.$router.push({
        name: `brokers.edit1`,
        params: { id: `${id}`, item: item },
      });
    },
    onAdd() {
      this.$router.push({ name: `brokers.create1` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Collaboratore Eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byAttribute.status_broker"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    onSaveFilter(name, criteria) {
      this.saveByName({ name, criteria });
    },
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
  },
  mounted() {
    this.onSearch(this.filterName);
    // this.$refs[this.tableRef].fetch();
  },
};
</script>
